import React from 'react';

// One account rendered as a flex card (replaces a wide table row so chips can
// wrap into the full width instead of being clipped). Used by both the Super
// Admin (showThings) and Admin account lists.
const ChipList = ({items, variant}) => (
  <div className="d-flex flex-wrap" style={{maxHeight:'108px', overflowY:'auto'}}>
    {items.map((it, i) => (
      <span key={i} className={'badge badge-' + variant + ' m-r-5 m-b-5'}>{it.name}</span>
    ))}
  </div>
);

const Section = ({label, items, variant}) => (
  <div style={{flex:'1 1 260px', minWidth:'220px'}}>
    <small className="text-muted d-block m-b-5">{label} ({items.length})</small>
    {items.length ? <ChipList items={items} variant={variant}/> : <span className="text-muted">—</span>}
  </div>
);

const AccountCard = ({account, onEdit, onManageProfiles, showThings}) => {
  const profiles = account.profile_list || [];
  const things = account.thing_list || [];
  const active = account.sys_status_id === 1;
  return (
    <div className="card m-b-10" style={{border:'1px solid #e0e0e0'}}>
      <div className="card-body" style={{padding:'15px'}}>
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex flex-column m-r-15">
            <span style={{fontWeight:600}}>{account.account_name}</span>
            <small className="text-muted">{account.email}</small>
          </div>
          <div className="d-flex align-items-center">
            <span className="m-r-10">
              {active ? <span className="badge badge-success">ACTIVE</span> : <span className="badge badge-danger">INACTIVE</span>}
            </span>
            <div className="btn-group">
              <button className="btn btn-sm btn-default" onClick={() => onEdit(account)}>Edit</button>
              <button className="btn btn-sm btn-primary" onClick={() => onManageProfiles(account)}>Manage Profiles</button>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap m-t-15">
          <Section label="Profiles" items={profiles} variant="primary"/>
          {showThings && <Section label="Things" items={things} variant="default"/>}
        </div>
      </div>
    </div>
  );
};

export default AccountCard;
